import Immutable from 'seamless-immutable';

import { createReducer, createActions } from 'reduxsauce';

export const { Types, Creators } = createActions({
  getProduct: ['id', 'query', 'sandbox'],
  getProductSuccess: ['data'],
  getProductFailed: ['error'],

  productPersonalizedRequest: ['id'],
  productPersonalizedSuccess: ['data'],

  setCurrentProduct: ['sku', 'offer'],
  setVariations: ['variations'],
  setCurrentVariation: ['currentVariation'],

  getBuyTogetherSuccess: ['data'],
  getBuyTogetherError: ['error'],

  setProductBuyTogetherRequest: ['data'],
  setProductBuyTogetherSuccess: ['data'],
  setProductBuyTogetherError: ['error'],

  notifyMeRequest: ['name', 'mail'],
  notifyMeSuccess: [],
  notifyMeFailed: [],

  sendSpecialistContactRequest: ['data'],
  sendSpecialistContactSuccess: ['data'],
  sendSpecialistContactError: ['error'],
});

const INITIAL_STATE = Immutable({
  currentSku: {},
  currentOffer: {},
  buyTogether: {},
  personalizedAttributes: [],
  isLoading: false,
  error: {},
  notifyMe: {},
  specialistContact: {},
  variations: [],
  currentVariation: [],
});

const request = (state = INITIAL_STATE) => state.merge({ isLoading: true, error: {} });

const productPersonalizedSuccess = (state = INITIAL_STATE, { data }) => state.set('personalizedAttributes', data);

const getProductSuccess = (state = INITIAL_STATE, { data }) => state.merge(data).set('isLoading', false);

const getProductError = (state = INITIAL_STATE, { error }) => state.merge({ error, isLoading: false });

const setCurrentProduct = (state = INITIAL_STATE, { sku: currentSku, offer: currentOffer }) =>
  state
    .merge({ currentSku, currentOffer })
    .setIn(['currentOffer', 'inStock'], Boolean(Immutable.getIn(currentOffer, ['_links', 'sku'])));

const getBuyTogetherSuccess = (state = INITIAL_STATE, { data }) => state.merge(data);

const getBuyTogetherError = (state = INITIAL_STATE, { error }) => state.set('error', error);

const setProductBuyTogetherSuccess = (state = INITIAL_STATE, { data }) =>
  state.merge({
    buyTogether: {
      [data.type]: {
        ...state.getIn(['buyTogether', data.type]),
        selectedItems: data.selectedItems,
      },
    },
  });

const setProductBuyTogetherError = (state = INITIAL_STATE, { error }) =>
  state.set('error', ...error).set('isLoading', false);

const notifyMeError = (state = INITIAL_STATE) => state.setIn(['notifyMe', 'error'], true).set('isLoading', false);

const notifyMeSuccess = (state = INITIAL_STATE) => state.setIn(['notifyMe', 'success'], true).set('isLoading', false);

const sendSpecialistContactRequest = (state = INITIAL_STATE) => state.setIn(['specialistContact', 'isLoading'], true);

const sendSpecialistContactSuccess = (state = INITIAL_STATE, { data }) =>
  state.setIn(['specialistContact', 'data'], data).setIn(['specialistContact', 'isLoading'], false);

const sendSpecialistContactError = (state = INITIAL_STATE, { error }) =>
  state.setIn(['specialistContact', 'error'], error).setIn(['specialistContact', 'isLoading'], false);

const setVariations = (state = INITIAL_STATE, { variations }) => state.set('variations', variations);

const setCurrentVariation = (state = INITIAL_STATE, { currentVariation }) =>
  state.set('currentVariation', currentVariation);

export default createReducer(INITIAL_STATE, {
  [Types.GET_PRODUCT]: request,
  [Types.GET_PRODUCT_SUCCESS]: getProductSuccess,
  [Types.GET_PRODUCT_FAILED]: getProductError,

  [Types.PRODUCT_PERSONALIZED_SUCCESS]: productPersonalizedSuccess,

  [Types.SET_CURRENT_PRODUCT]: setCurrentProduct,

  [Types.SET_VARIATIONS]: setVariations,

  [Types.SET_CURRENT_VARIATION]: setCurrentVariation,

  [Types.GET_BUY_TOGETHER_SUCCESS]: getBuyTogetherSuccess,
  [Types.GET_BUY_TOGETHER_ERROR]: getBuyTogetherError,

  [Types.SET_PRODUCT_BUY_TOGETHER_SUCCESS]: setProductBuyTogetherSuccess,
  [Types.SET_PRODUCT_BUY_TOGETHER_ERROR]: setProductBuyTogetherError,

  [Types.NOTIFY_ME_REQUEST]: request,
  [Types.NOTIFY_ME_SUCCESS]: notifyMeSuccess,
  [Types.NOTIFY_ME_FAILED]: notifyMeError,

  [Types.SEND_SPECIALIST_CONTACT_REQUEST]: sendSpecialistContactRequest,
  [Types.SEND_SPECIALIST_CONTACT_SUCCESS]: sendSpecialistContactSuccess,
  [Types.SEND_SPECIALIST_CONTACT_ERROR]: sendSpecialistContactError,
});
